const Footer = () => {
    return (
        <footer className="footer">
            <p>Made by <a href="https://ryanstchang.dev">Ryan</a> </p>
        </footer>
    );
}

export default Footer;